import cx from 'classnames';
import parse from 'html-react-parser';
import dynamic from 'next/dynamic';
import { FunctionComponent, ReactNode } from 'react';

import IconCheck from '../../ui/icons/check';

const ExtraInfo = dynamic(() => import('./extra-info-modal'));

type TCheckList = {
  items: Array<{
    key: string;
    icon?: ReactNode;
    content: ReactNode;
    modal?: { title?: string; content: ReactNode };
  }>;
  background?: boolean;
};

const CheckList: FunctionComponent<TCheckList> = ({
  items,
  background = true,
}) => {
  return (
    <ul
      className={cx(
        { 'bg-neutral-10': background },
        'lg:bg-transparent',
        'px-0 grid grid-cols-1 gap-4'
      )}
    >
      {items.map((item) => (
        <li
          key={item.key}
          className={cx('grid grid-cols-[16px_1fr] gap-4', 'items-center')}
        >
          {item?.icon ? (
            <div>{item?.icon}</div>
          ) : (
            <IconCheck className={cx('w-3', 'mt-1')} />
          )}
          <p className={cx('text-base text-left')}>
            {item.content}
            {item?.modal && (
              <ExtraInfo
                title={item.modal?.title}
                content={parse(item.modal.content)}
              />
            )}
          </p>
        </li>
      ))}
    </ul>
  );
};

export default CheckList;
